import * as React from "react";
import styled from "@emotion/styled";

const Col = styled.div<{ size: number, float?: string }>`
  display: block;
  float: ${({ float = "left" }) => float};
  padding: 0 1rem;
  ${({ size }) => `width: ${(size / 12) * 100}%`}
`;

export interface IProps {
  float?: string;
  size: number;
  children: React.ReactNode;
}
export default (props: IProps) => <Col size={props.size} float={props.float}>{props.children}</Col>;
